import React, { useEffect, useRef, useState } from "react";
import ebenchLogo from "../../../images/ebench_logo.png";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { CgProfile } from "react-icons/cg";
import { FiLogOut } from "react-icons/fi";
import {
  MdInsertInvitation,
  MdOutlineArrowDropDown,
  MdOutlineArrowDropUp,
  MdOutlineWorkOutline,
  MdPersonalVideo,
} from "react-icons/md";
import dummyDp from "../../../images/dummy_dp.png";
import { IoNewspaperOutline, IoPeopleOutline } from "react-icons/io5";
import { RiUserSearchLine, RiWebcamLine } from "react-icons/ri";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import { VendorProfile } from "../../../Redux/action/VendorProfileAction";
import { toast, Zoom } from "react-toastify";
import { HiOutlineBellAlert } from "react-icons/hi2";
import {
  GetAllNotification,
  ViewNotification,
} from "../../../Services/notificationServices";
import { logoutUser } from "../../../Services/authService";
import {
  connectWebSocket,
  disconnectWebSocket,
} from "../../../utils/websocketService";
import { AiOutlineProject } from "react-icons/ai";
import { FaMoneyCheck, FaUserTag } from "react-icons/fa";
import { SIGNOUT_USER_SUCCESS } from "../../../Redux/constants/AuthConstant";
import { persistor } from "../../../Redux/store";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [scrolled, setScrolled] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [notificationList, setNotificationList] = useState([]);
  const [width, setWidth] = useState(window.innerWidth);

  const optionsRef = useRef(null);
  const notificationsRef = useRef(null);

  const profilePic = useSelector(
    (state) => state?.Profile?.result?.profileImageUrl
  );
  const vendorPic = useSelector(
    (state) => state.VendorProfile.result?.companyLogoUrl
  );
  const vendorIdData = useSelector((state) => state.Profile.result?.vendorId);
  const { userResult } = useSelector((state) => state.Auth);
  const usertype = userResult?.usertype;
  const candidateId1 = userResult?.userid;
  const vendorId = userResult?.vendorid;

  const firstName = useSelector((state) => {
    if (usertype === "CANDIDATE") return state?.Profile?.result?.firstName;
    return state?.VendorProfile?.result?.firstName;
  });

  const isAccountVerified = useSelector(
    (state) => state?.VendorProfile?.result?.isAccountVerified
  );

  const msadocUrl = useSelector(
    (state) => state?.VendorProfile?.result?.msadocUrl
  );

  // Scroll shadow
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Vendor profile fetch
  useEffect(() => {
    if (vendorId) dispatch(VendorProfile());
  }, [vendorId]);

  // Logout
  const handleLogout = async () => {
    try {
      const id = usertype !== "VENDOR" ? candidateId1 : vendorId;
      const role = usertype === "VENDOR" ? "VENDOR" : "CANDIDATE";
      await logoutUser(parseInt(id), role);

      navigate("/");

      localStorage.clear();
      await persistor.purge();

      dispatch({
        type: SIGNOUT_USER_SUCCESS,
        payload: {},
        isSigninIn: false,
        msg: "logout successfully",
      });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  useEffect(() => {
    if (!candidateId1 && !vendorId) return;

    const id = usertype !== "VENDOR" ? candidateId1 : vendorId;
    const role = usertype === "VENDOR" ? "VENDOR" : "CANDIDATE";

    const fetchNotifications = async () => {
      const res = await GetAllNotification({ id, role });
      const notifications = res.data.data || [];
      setNotificationList(notifications);
      const unread = notifications.filter(
        (n) => n.readStatus === "FALSE"
      ).length;
      setUnreadCount(unread);
    };

    fetchNotifications();

    const handleNewNotification = (newNotification) => {
      if (!newNotification) return;
      setNotificationList((prev) => [newNotification, ...prev]);
      console.log({ notificationList });
      setUnreadCount((prev) => prev + 1);
    };

    const handleUnreadUpdate = (unread) => setUnreadCount(unread);

    connectWebSocket(role, id, handleNewNotification, handleUnreadUpdate);

    return () => disconnectWebSocket();
  }, [candidateId1, vendorId, usertype]);

  const handleViewNotification = async (role) => {
    const id = usertype !== "VENDOR" ? candidateId1 : vendorId;
    await ViewNotification({ id, role });
    setUnreadCount(0);
    const res = await GetAllNotification({ id, role });
    setNotificationList(res.data.data);
  };

  const getTimeAgo = (timestamp) => {
    if (!timestamp) return "Invalid date";
    const created = new Date(Number(timestamp));
    if (isNaN(created)) return "Invalid date";

    const diffSec = Math.floor((Date.now() - created) / 1000);
    if (diffSec < 60) return `${diffSec}s ago`;
    if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
    if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
    return `${Math.floor(diffSec / 86400)}d ago`;
  };

  // Close dropdowns on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        optionsRef.current &&
        !optionsRef.current.contains(event.target) &&
        notificationsRef.current &&
        !notificationsRef.current.contains(event.target)
      ) {
        setShowOptions(false);
        setShowNotifications(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Responsive width
  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const dropdownItemStyle = {
    padding: "10px 16px",
    fontSize: "14px",
    color: "#444",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    transition: "0.2s",
  };

  const handleVerification = (item) => {
    if (!isAccountVerified) {
      toast.warn(
        msadocUrl
          ? "Verification pending from admin"
          : "Please complete your profile",
        {
          toastId: "warningError",
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Zoom,
        }
      );
      return false;
    }
    navigate(item);
  };

  // Precompute responsive styles
  const padding = width < 520 ? "10px 6px" : "10px 30px";
  const gap = width < 520 ? "5px" : "20px";

  return (
    <header
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding,
        background: "#fff",
        boxShadow: scrolled
          ? "0 2px 8px rgba(0,0,0,0.1)"
          : "0 2px 8px rgba(0,0,0,0.1)",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      {/* Logo */}
      <Link
        to={
          usertype === "VENDOR" ? "/vendor_dashboard" : "/candidate_dashboard"
        }
      >
        <img
          src={ebenchLogo}
          alt="Ebench"
          style={{
            maxHeight: width < 520 ? "25px" : "40px",
            height: "auto",
            width: "auto",
            maxWidth: "100%",
          }}
        />
      </Link>

      {/* Right Side */}
      <div style={{ display: "flex", alignItems: "center", gap }}>
        {/* Notifications */}
        <div
          ref={notificationsRef}
          style={{ position: "relative", marginLeft: "15px" }}
        >
          <HiOutlineBellAlert
            size={24}
            style={{ color: "#286a94", cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              setShowNotifications(!showNotifications);
              setShowOptions(false);
              handleViewNotification(usertype);
            }}
          />
          {unreadCount > 0 && (
            <span
              style={{
                position: "absolute",
                top: "-8px",
                right: "-8px",
                background: "red",
                color: "white",
                borderRadius: "50%",
                padding: "2px 6px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {unreadCount}
            </span>
          )}
          {showNotifications && (
            <div
              style={{
                position: "absolute",
                right: width < 520 ? "-32px" : 0,
                marginTop: "10px",
                width: width < 520 ? "220px" : "280px",
                background: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                borderRadius: "8px",
                padding: "10px",
                maxHeight: "300px",
                overflowY: "auto",
                zIndex: 999,
              }}
            >
              <h4
                style={{
                  margin: "0 0 5px 0",
                  fontSize: "14px",
                  color: "#333",
                  fontWeight: "600",
                }}
              >
                Notifications
              </h4>
              {notificationList?.length > 0 ? (
                notificationList.map((data) => (
                  <div
                    key={data?.notificationId}
                    style={{
                      fontSize: "13px",
                      padding: "8px 0",
                      borderBottom: "1px solid #eee",
                      color: "#444",
                    }}
                  >
                    🔔 {data?.message}
                    <div style={{ fontSize: "11px", color: "#888" }}>
                      {getTimeAgo(data?.createdDate)}
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ fontSize: "13px", color: "#666" }}>
                  No new notifications
                </p>
              )}
            </div>
          )}
        </div>

        {/* Profile Dropdown */}
        <div ref={optionsRef} style={{ position: "relative" }}>
          <div
            onClick={() => {
              setShowOptions(!showOptions);
              setShowNotifications(false); // close notifications if open
            }}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              padding: width < 520 ? "6px 0px" : "6px 10px",
              borderRadius: "6px",
              transition: "0.2s",
            }}
          >
            <img
              src={
                userResult?.usertype === "VENDOR"
                  ? vendorPic || dummyDp
                  : userResult?.usertype === "CANDIDATE"
                  ? vendorPic || profilePic || dummyDp
                  : dummyDp
              }
              alt="profile"
              style={{
                width: width < 520 ? "30px" : "55px",
                height: width < 520 ? "30px" : "55px",
                borderRadius: "50%",
                objectFit: "cover",
                border: "2px solid #286a94",
                marginRight: "8px",
              }}
            />
            <div
              style={{ display: "flex", flexDirection: "column", gap: "5px" }}
            >
              <span
                style={{
                  fontSize: width < 520 ? "10px" : "14px",
                  fontWeight: 600,
                  color: "#286a94",
                  textTransform: "capitalize",
                }}
              >
                {firstName}
              </span>
              <span
                style={{
                  background: "linear-gradient(135deg, #2c7aa7, #1f5676)",
                  color: "#ffffff",
                  padding: width < 520 ? "3px 8px" : "4px 10px",
                  borderRadius: "14px",
                  fontSize: width < 520 ? "10px" : "12px",
                  fontWeight: 500,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                  letterSpacing: "0.3px",
                  transition: "all 0.2s ease-in-out",
                }}
              >
                <FaUserTag size={width < 520 ? 10 : 14} />
                {usertype}
              </span>
            </div>

            {showOptions ? (
              <MdOutlineArrowDropUp size={22} color="#286a94" />
            ) : (
              <MdOutlineArrowDropDown size={22} color="#286a94" />
            )}
          </div>
          {showOptions && (
            <ul
              style={{
                position: "absolute",
                right: 0,
                marginTop: "8px",
                background: "#fff",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                listStyle: "none",
                padding: "8px 0",
                width: "220px",
                zIndex: 999,
              }}
            >
              {/* Vendor Options */}
              {usertype === "VENDOR" && (
                <>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      navigate("/vendor_profile");
                      setShowOptions(false);
                    }}
                  >
                    <CgProfile size={18} /> View Profile
                  </li>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      handleVerification("/team-list");
                    }}
                  >
                    <IoPeopleOutline size={18} /> Team Member
                  </li>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      handleVerification("/schedule-interview");
                    }}
                  >
                    <RiWebcamLine size={18} /> Interviews
                  </li>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      handleVerification("/posted_jobs");
                    }}
                  >
                    <IoNewspaperOutline size={18} /> Jobs
                  </li>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      handleVerification("/all-candidate-list");
                    }}
                  >
                    <RiUserSearchLine size={18} /> Search Candidate
                  </li>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      handleVerification("/purchase-details");
                    }}
                  >
                    <LiaFileInvoiceSolid size={18} /> Purchase Order
                  </li>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      navigate("/vendor_subscription");
                      setShowOptions(false);
                    }}
                  >
                    <RiWebcamLine size={18} /> Subscription
                  </li>
                </>
              )}

              {/* Candidate Options */}
              {usertype !== "VENDOR" && (
                <>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      navigate("/candidate-profile");
                      setShowOptions(false);
                    }}
                  >
                    <CgProfile size={18} /> View Profile
                  </li>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      navigate("/show-candidate-projects");
                      setShowOptions(false);
                    }}
                  >
                    <AiOutlineProject size={18} /> Projects
                  </li>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      navigate("/candidate_interviews");
                      setShowOptions(false);
                    }}
                  >
                    <MdPersonalVideo size={18} /> Interviews
                  </li>
                  <li
                    style={dropdownItemStyle}
                    onClick={() => {
                      navigate("/new_job");
                      setShowOptions(false);
                    }}
                  >
                    <MdOutlineWorkOutline size={18} /> Jobs
                  </li>
                  {vendorIdData === null && (
                    <>
                      <li
                        style={dropdownItemStyle}
                        onClick={() => {
                          navigate("/invitations");
                          setShowOptions(false);
                        }}
                      >
                        <MdInsertInvitation size={18} /> Invitations
                      </li>
                      <li
                        style={dropdownItemStyle}
                        onClick={() => {
                          navigate("/purchase-details");
                          setShowOptions(false);
                        }}
                      >
                        <FaMoneyCheck size={18} /> Purchase Order
                      </li>
                      <li
                        style={dropdownItemStyle}
                        onClick={() => {
                          navigate("/subscription");
                          setShowOptions(false);
                        }}
                      >
                        <RiWebcamLine size={18} /> Subscription
                      </li>
                    </>
                  )}
                </>
              )}
              {/* Logout */}
              <li
                style={{
                  ...dropdownItemStyle,
                  color: "red",
                  borderTop: "1px solid #eee",
                  marginTop: "6px",
                  paddingTop: "10px",
                }}
                onClick={() => {
                  handleLogout();
                  setShowOptions(false);
                }}
              >
                <FiLogOut size={18} /> Logout
              </li>
            </ul>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
